module.exports = __webpack_public_path__ + "img/Icone__todas_.82683452.svg";